<template>
  <div
    class="pt-5 pl-2 sm:pl-4 flex flex-col megamenu__parent"
    :class="`megamenu__parent--${data.id}`"
    :data-id="data.id"
  >
    <button
      type="button"
      class="megamenu__link relative p-2 sm:p-3 lg:p-4 flex flex-col flex-grow-1 shadow text-center"
      :class="activeClass"
      :aria-expanded="openedMenuId === data.id"
      :aria-controls="`${megamenuId}--${data.id}`"
      @click="click"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
    >
      <div class="megamenu__icon embed-responsive mb-0 lg:mb-n2 mt-n5">
        <Component
          :is="data.svg"
          v-bind="data.imageEvent !== '' ? { type: data.imageEvent } : {}"
          class="icon embed-responsive-item image-contain px-4"
          @loaded="svgLoaded($event)"
        />
      </div>
      <p class="font-medium mt-O mb-0 ml-auto mr-auto relative">
        {{ data.title }}
      </p>
      <p class="mb-0 relative ml-auto mr-auto">
        <span class="hidden lg:block">{{ data.desktopText }}</span>
        <span class="lg:hidden">{{ data.mobileText }}</span>
      </p>
    </button>
  </div>
</template>

<script setup>
import { computed, nextTick } from 'vue'
import { useRoute } from 'vue-router'

import { useModalStore } from '@/stores/ModalStore'

const route = useRoute()
const { openModal } = useModalStore()

const props = defineProps({
  openedMenuId: {
    type: String,
    default: undefined,
  },

  openSubmenu: {
    type: Function,
    required: true,
  },

  hideSubmenu: {
    type: Function,
    required: true,
  },

  megamenuId: {
    type: String,
    default: 'megamenu--secondary',
  },

  data: {
    type: Object,
    default() {
      return {
        id: {
          type: String,
          validator: (value) => {
            return ['mix', 'ready', 'club'].includes(value)
          },
        },

        desktopText: {
          type: String,
        },

        mobileText: {
          type: String,
        },

        link: {
          type: String,
        },

        image: {
          type: String,
        },

        imageEvent: {
          type: String,
        },

        isCurrent: {
          type: Boolean,
          default: false,
        },
      }
    },
  },
})

const activeClass = computed(() => {
  return route.name === props.data.link.name ? ' megamenu__link--current' : ''
})

const click = (event) => {
  event.preventDefault()
  event.stopPropagation()

  if (props.megamenuId === 'megamenu--homepage' && window.innerWidth < 992) {
    openModal({ id: 'modal-id-menu' })
    // open same item in modal
    nextTick(() => {
      const modalEl = document.querySelector('#modal-id-menu')
      const sameMenuParentItemInModal = modalEl.querySelector(`.megamenu__parent--${props.data.id} > button`)
      sameMenuParentItemInModal.click()
    })
  } else if (props.openedMenuId === props.data.id && window.innerWidth < 992) {
    props.hideSubmenu(props.data.id)
  } else {
    props.openSubmenu(props.data.id)
    const mainHeadline = document.querySelector('.main-headline')
    const secondaryMenu = document.querySelector('.megamenu--secondary')
    if (mainHeadline) {
      window.scrollTo({
        top: mainHeadline.offsetTop + mainHeadline.offsetHeight - 30,
        behavior: 'smooth',
      })
    }
    if (secondaryMenu) {
      window.scrollTo({
        top: 230,
        behavior: 'smooth',
      })
    }
  }
}

const mouseenter = () => {
  if (window.innerWidth >= 992) props.openSubmenu(props.data.id)
}

const mouseleave = (event) => {
  if (window.innerWidth >= 992 && event.relatedTarget && !event.relatedTarget.closest('.megamenu__child')) {
    props.hideSubmenu(props.data.id)
  }
}

const svgLoaded = (svg) => {
  svg.classList.add('embed-responsive-item', 'image-contain')
}
</script>
